/* global axios */
import ApiClient from './ApiClient';

class UserLoginLogsAPI extends ApiClient {
  constructor() {
    super('user_login_logs', { accountScoped: true });
  }

  get({ page, since, until: untilTs, userId } = {}) {
    return axios.get(this.url, {
      params: { page, since, until: untilTs, user_id: userId },
    });
  }

  download({ since, until: untilTs, userId } = {}) {
    return axios.get(`${this.url}/download`, {
      params: { since, until: untilTs, user_id: userId },
      responseType: 'blob',
    });
  }
}

export default new UserLoginLogsAPI();
